export default __webpack_public_path__ + "1f47d6ffd1dad2155eff03be300fd519.png";